export const LogindisabledMesage =
  " Sorry you can't login now as quiz already started.";
export const QuizStartedErrorMessage =
  "Quiz already started. You can't login now";
export const EmailAlreadyExistsErrorMessage = "Email already Exists";
export const InvalidEmailErrorMessage = "Please enter valid email address";
export const RequiredFieldErrorMessage = "this field is required";
export const ThankYouMessage = "Thank you for participating the quiz";
export const TimesUpMessage = "Oops! <br /> Time is Up! ";
export const WelcomeMessage = `Hello {user}, Quiz will start in few minutes. please wait..`;
export const NoInternetMessage =
  "You are currently offline. Please check your internet connection.";
export const QuestionMarks = 1;
export const Timer = 15;
